export const darkTheme = {
  darkTheme: {
    announcementTitle: "Now we have a Dark Theme 🎉",
    announcementDisclaimer: "You can change it later on Menu",
    tryNow: "Give it a try:",
  },
};
